import { Navigate } from "react-router-dom";
import { useAppSelector } from "src/store/hooks";

// Used to enforce routes that a user should be logged in for
export default function UserProtectedRoute({ children }: any) {
  const { isAuth } = useAppSelector((state) => state.user);

  return isAuth ? children : <Navigate to='/login' />;
}